module.exports = __webpack_public_path__ + "img/UA.8a287858.svg";